import React, { useContext } from "react";

// Context
import { AppContext } from "@vahak/core/dist/app-context";

// Layouts
import SideNavLayoutWrapper from "../SideNavLayoutWrapper/SideNavLayoutWrapper";
import BottomNavLayout, { BottomNavLayoutProps } from "../bottom-nav-layout/BottomNavLayout";
import { SideNavLayoutProps } from "../side-nav-layout/SideNavLayout";
import TopNavLayout, { TopNavLayoutProps } from "../top-nav-layout/TopNavLayout";
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";
import TopNavV2 from "../top-nav-v2/TopNavV2";

export interface DefaultLayoutProp extends TopNavLayoutProps, SideNavLayoutProps, BottomNavLayoutProps {
    hideTopNav?: boolean;
}

const DefaultLayout = ({ ...props }: DefaultLayoutProp) => {
    const { isPhoneVerified, companyId } = useContext(AppContext);
    const { content: Content, children, navContent, hideTopNav } = props;

    //TODO: GOWDHAM - Need to refactor this issue
    const mobileScreen = useMediaQuery({ queryType: "mobile" });

    const isFullyLoggedIn = Boolean(isPhoneVerified && companyId);

    // Keep SideNav for logged-in marketplace. Swapping to TopNav on Bid remounts the page
    // under the click, so the overlay receives the leftover click and the sheet closes.
    if (!isFullyLoggedIn) {
        return (
            <TopNavLayout navContent={<TopNavV2 />} content={Content}>
                {children}
            </TopNavLayout>
        );
    }

    if (isPhoneVerified && companyId && !mobileScreen) {
        return <SideNavLayoutWrapper>{Content ? <Content /> : children}</SideNavLayoutWrapper>;
    }

    if (isPhoneVerified && companyId && mobileScreen) {
        return (
            // <BottomNavLayout topNavContent={<Topbar t={t} router={router} />} navContent={navContent}>
            <BottomNavLayout topNavContent={hideTopNav ? undefined : <TopNavV2 />} navContent={navContent}>
                {Content ? <Content /> : children}
            </BottomNavLayout>
        );
    }

    return <></>;
};

export default DefaultLayout;
